import type { TSelectedZones } from '../ModalDrawerBulkEdit'

export const areAllZonesSelected = (selectableZones: TSelectedZones[], selectedZones: TSelectedZones[]) => {
  const selectedIds = new Set(selectedZones.map((zone) => zone.id))

  return selectableZones.every((zone) => selectedIds.has(zone.id))
}
